module.exports = __webpack_public_path__ + "img/nuwa_developer_info.2c950240.png";